var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.getters.isBrowser)?_c('web-transmission'):_c('pc-transmission')],1)}
var staticRenderFns = []

export { render, staticRenderFns }